export const purpleCssGradient = {
    textGradient: '45deg, $purple500 -20%, $pink500 100%'
  }